import React from 'react';
import { LayoutDashboardIcon, MapIcon, FileTextIcon, BellIcon, SettingsIcon } from 'lucide-react';
import { useApp } from '../../context/AppContext';
import { ViewType } from '../../data/types';
interface MobileNavItem {
  id: ViewType;
  label: string;
  icon: React.ReactNode;
}
const mobileNavItems: MobileNavItem[] = [{
  id: 'dashboard',
  label: 'Home',
  icon: <LayoutDashboardIcon className="w-5 h-5" data-id="element-45" />
}, {
  id: 'land-records',
  label: 'Records',
  icon: <MapIcon className="w-5 h-5" data-id="element-46" />
}, {
  id: 'documents',
  label: 'Docs',
  icon: <FileTextIcon className="w-5 h-5" data-id="element-47" />
}, {
  id: 'notifications',
  label: 'Alerts',
  icon: <BellIcon className="w-5 h-5" data-id="element-48" />
}, {
  id: 'settings',
  label: 'More',
  icon: <SettingsIcon className="w-5 h-5" data-id="element-49" />
}];
export function MobileNav() {
  const {
    state,
    navigate
  } = useApp();
  const {
    currentView,
    notifications
  } = state;
  const unreadCount = notifications.filter(n => !n.read).length;
  return <nav className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50" data-id="element-50">
      <div className="flex items-center justify-around py-2" data-id="element-51">
        {mobileNavItems.map(item => {
        const isActive = currentView === item.id || item.id === 'land-records' && (currentView === 'land-record-details' || currentView === 'land-record-edit' || currentView === 'create-record');
        return <button key={item.id} onClick={() => navigate(item.id)} className={`flex flex-col items-center gap-1 px-3 py-1 rounded-lg transition-colors ${isActive ? 'text-blue-600' : 'text-gray-500 hover:text-gray-900'}`} data-id="element-52">
              <span className="relative" data-id="element-53">
                {item.icon}
                {item.id === 'notifications' && unreadCount > 0 && <span className="absolute -top-1 -right-1 w-4 h-4 bg-red-500 rounded-full text-[10px] text-white flex items-center justify-center" data-id="element-54">
                    {unreadCount}
                  </span>}
              </span>
              <span className="text-xs font-medium" data-id="element-55">{item.label}</span>
            </button>;
      })}
      </div>
    </nav>;
}